/**
 * PDP You May Also Like – swatch variant selection.
 * Reuses the same product-card snippet & CSS classes as home-bestsellers.
 */

class PdpYouMayAlsoLike extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.section-home-bestsellers__swatch[data-variant-id]').forEach((swatch) => {
      swatch.addEventListener('click', () => this.onSwatchClick(swatch));
    });
  }

  onSwatchClick(swatch) {
    const card = swatch.closest('.section-home-bestsellers__card');
    if (!card) return;

    const variantId = swatch.dataset.variantId;
    const isAvailable = swatch.dataset.available === 'true';
    const imageUrl = swatch.dataset.image;
    const imageSrcset = swatch.dataset.imageSrcset;
    const price = swatch.dataset.price;
    const comparePrice = swatch.dataset.comparePrice;

    /* Update swatch selection */
    card.querySelectorAll('.section-home-bestsellers__swatch').forEach((s) => {
      s.classList.remove('section-home-bestsellers__swatch--selected');
    });
    swatch.classList.add('section-home-bestsellers__swatch--selected');

    /* Update variant ID in the form */
    const variantInput = card.querySelector('input.product-variant-id');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = !isAvailable;
    }

    /* Update the submit button state */
    const submitBtn = card.querySelector('.section-home-bestsellers__add-to-cart-btn[type="submit"]');
    if (submitBtn) {
      const addText = submitBtn.dataset.addToCartText;
      const soldOutText = submitBtn.dataset.soldOutText;
      const labelSpan = submitBtn.querySelector('span:not(.sold-out-message):not(.loading__spinner)');

      if (isAvailable) {
        submitBtn.removeAttribute('disabled');
        if (labelSpan && addText) labelSpan.textContent = addText;
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
        if (labelSpan && soldOutText) labelSpan.textContent = soldOutText;
      }
    }

    /* Update card image */
    if (imageUrl) {
      const img = card.querySelector('.section-home-bestsellers__card-img');
      if (img) {
        img.src = imageUrl;
        if (imageSrcset) img.srcset = imageSrcset;
      }
    }

    /* Update price display */
    if (price) {
      const priceEl = card.querySelector('.section-home-bestsellers__card-price');
      if (priceEl) priceEl.textContent = price;
    }

    const comparePriceEl = card.querySelector('.section-home-bestsellers__card-compare-price');
    if (comparePrice) {
      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.style.display = '';
      } else {
        const pricesWrap = card.querySelector('.section-home-bestsellers__card-prices');
        if (pricesWrap) {
          const s = document.createElement('s');
          s.className = 'section-home-bestsellers__card-compare-price';
          s.textContent = comparePrice;
          pricesWrap.appendChild(s);
        }
      }
    } else if (comparePriceEl) {
      comparePriceEl.style.display = 'none';
    }
  }
}

if (!customElements.get('pdp-you-may-also-like')) {
  customElements.define('pdp-you-may-also-like', PdpYouMayAlsoLike);
}
